export default {
  merchantObj: {
    bizParam: {
      address: null,
      addressLat: 0,
      addressLng: 0,
      areaId: 0,
      assetsType: null,
      bankImg: null,
      bankName: null,
      bankNo: null,
      businessAddress: '',
      businessScope: null,
      category: 0,
      certNo: null,
      certificateImg: null,
      cityId: 0,
      cityIds: null,
      code: null,
      cooperationImg: null,
      createTime: null,
      createUserId: 0,
      creditAmount: null,
      creditCode: null,
      delServiceCategoryIds: null,
      id: null,
      idCard: null,
      isAudit: true,
      isCertification: true,
      isDelete: false,
      isEnabled: false,
      legalPersonImg: null,
      legalPersonName: null,
      licenseImg: null,
      mainPerson: null,
      merchantCode: null,
      merchantExtend: null,
      merchantLevel: null,
      mobile: null,
      name: null,
      openRemind: false,
      parentId: 0,
      password: null,
      provinceId: 0,
      seniorityImg: null,
      serviceCategoryIds: '',
      simple: false,
      taxNo: null,
      type: 0,
      updateTime: null,
      updateUserId: 0,
      userId: 0,
      userInfoMobile: null,
      version: 0
    },
    id: null,
    ip: null
  }
}
